import React from "react";
import {
  Typography,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip
} from "@mui/material";
import "./dashboard.css";

const Dashboard2 = ({ activityLog }) => {
  return (
    <>
      {/* Activity Log Header */}
      <Typography variant="h6" fontWeight="bold" mb={2}>📋 Daily Activity Log</Typography>

      {/* Activity Log Table */}
      <Paper elevation={3} className="activity-log">
        <TableContainer>
          <Table size="small">
            <TableHead className="activity-header">
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Lead Name</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell>Loan Type</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Disposition</TableCell>
                <TableCell>Follow-up</TableCell>
                <TableCell>Remarks</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {activityLog.map((entry, idx) => (
                <TableRow key={idx} className={idx % 2 === 0 ? "row-even" : "row-odd"}>
                  <TableCell>{entry.time}</TableCell>
                  <TableCell>{entry.leadName}</TableCell>
                  <TableCell>{entry.mobile}</TableCell>
                  <TableCell>{entry.loanType}</TableCell>
                  <TableCell>
                    <Chip
                      label={entry.status}
                      size="small"
                      color={
                        entry.status === "Connected" ? "success" :
                        entry.status === "No Answer" ? "warning" : "default"
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={entry.disposition}
                      size="small"
                      color={entry.disposition === "Interested" ? "primary" : "secondary"}
                    />
                  </TableCell>
                  <TableCell>{entry.followUp}</TableCell>
                  <TableCell>{entry.remarks}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default Dashboard2;